// Stroke-order paths for shapes and letters.
// ViewBox is 0 0 100 100 for all entries.
// Each value is an ordered array of SVG path "d" strings — one per stroke,
// in the order a child should write them.

export const STROKES = {
  // ---- SHAPES ----
  Line: ["M 15 50 L 85 50"],
  Circle: ["M 50 15 Q 15 15 15 50 Q 15 85 50 85 Q 85 85 85 50 Q 85 15 50 15"],
  Square: ["M 18 18 L 82 18 L 82 82 L 18 82 Z"],
  Triangle: ["M 50 15 L 85 82 L 15 82 Z"],
  Zigzag: ["M 12 30 L 32 70 L 52 30 L 72 70 L 88 30"],
  Wave: ["M 8 55 Q 22 25 38 55 T 68 55 T 92 55"],
  Spiral: [
    "M 50 50 m 0 0 q 6 -6 12 0 q 6 8 -4 14 q -14 6 -18 -8 q -4 -18 14 -22 q 22 -4 26 16 q 4 26 -22 30",
  ],
  Plus: ["M 50 18 L 50 82", "M 18 50 L 82 50"],

  // ---- LETTERS (uppercase) ----
  A: ["M 18 85 L 50 15 L 82 85", "M 30 60 L 70 60"],
  B: [
    "M 28 15 L 28 85",
    "M 28 15 Q 70 15 70 32 Q 70 50 28 50",
    "M 28 50 Q 75 50 75 67 Q 75 85 28 85",
  ],
  C: ["M 82 28 Q 50 10 25 30 Q 10 50 25 70 Q 50 90 82 72"],
  D: ["M 28 15 L 28 85", "M 28 15 Q 78 15 78 50 Q 78 85 28 85"],
  E: ["M 72 15 L 28 15 L 28 85 L 72 85", "M 28 50 L 62 50"],
  F: ["M 28 85 L 28 15 L 72 15", "M 28 50 L 60 50"],
  G: [
    "M 82 28 Q 50 10 25 30 Q 10 50 25 70 Q 50 90 78 78 L 78 55 L 55 55",
  ],
  H: ["M 25 15 L 25 85", "M 75 15 L 75 85", "M 25 50 L 75 50"],
  I: ["M 30 15 L 70 15", "M 50 15 L 50 85", "M 30 85 L 70 85"],
  J: ["M 30 15 L 70 15", "M 58 15 L 58 70 Q 58 88 38 85 Q 20 82 20 70"],
  K: ["M 25 15 L 25 85", "M 75 15 L 25 50", "M 25 50 L 75 85"],
  L: ["M 28 15 L 28 85 L 75 85"],
  M: ["M 18 85 L 25 15 L 50 65 L 75 15 L 82 85"],
  N: ["M 22 85 L 25 15 L 75 85 L 78 15"],
  O: ["M 50 15 Q 18 15 18 50 Q 18 85 50 85 Q 82 85 82 50 Q 82 15 50 15"],
  P: ["M 28 85 L 28 15", "M 28 15 Q 75 15 75 32 Q 75 50 28 50"],
  Q: [
    "M 50 15 Q 18 15 18 50 Q 18 85 50 85 Q 82 85 82 50 Q 82 15 50 15",
    "M 60 65 L 88 90",
  ],
  R: [
    "M 28 85 L 28 15",
    "M 28 15 Q 75 15 75 32 Q 75 50 28 50",
    "M 48 50 L 78 85",
  ],
  S: ["M 75 28 Q 55 12 32 25 Q 15 40 45 50 Q 80 58 70 75 Q 50 90 22 78"],
  T: ["M 15 15 L 85 15", "M 50 15 L 50 85"],
  U: ["M 25 15 L 25 60 Q 25 85 50 85 Q 75 85 75 60 L 75 15"],
  V: ["M 18 15 L 50 85 L 82 15"],
  W: ["M 15 15 L 30 85 L 50 35 L 70 85 L 85 15"],
  X: ["M 18 15 L 82 85", "M 82 15 L 18 85"],
  Y: ["M 22 15 L 50 50", "M 78 15 L 50 50", "M 50 50 L 50 85"],
  Z: ["M 18 15 L 82 15 L 18 85 L 82 85"],
};

export const hasStrokes = (text) => {
  if (!text) return false;
  if (STROKES[text]) return true;
  if (text.length === 1 && STROKES[text.toUpperCase()]) return true;
  return false;
};

export const getStrokes = (text) => {
  if (STROKES[text]) return STROKES[text];
  if (text.length === 1) return STROKES[text.toUpperCase()];
  return null;
};
